/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
// Ember imports
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { isEmpty } from '@ember/utils';
// Internal imports
import InterventionStatus from 'linced-app/enums/intervention-status';

export default class InterventionsRoute extends Route {
  queryParams = {
    status: {
      refreshModel: true,
    },
    academicYear: {
      refreshModel: true,
    },
    termNumber: {
      refreshModel: true,
    },
  };

  InterventionStatus = InterventionStatus;

  // Services
  @service
  store;

  model(params) {
    if (isEmpty(params.termNumber)) {
      // If the term has been cleared from the dropdown,
      // we need to set it 0 instead of null
      params.termNumber = 0;
    }
    return hash({
      interventions: this.store.query('attendance/intervention', params),
      // Query for all archived interventions to make up the filters on the "Completed"
      // tab regardless of the chosen tab
      archivedInterventions: this.store.query('attendance/intervention', {
        status: InterventionStatus.ACTIONED,
      }),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    // Set filters if needed
    if (!isEmpty(model.archivedInterventions)) {
      // We want unique years for year filters on the "Completed" tab
      let years = new Set();
      model.archivedInterventions.forEach((intervention) => {
        years.add(intervention.academicYear);
      });
      this.controllerFor('admin/interventions').set(
        'years',
        Array.from(years).sort((a, b) => b - a),
      );
    }
  }
}
